module.exports = __webpack_public_path__ + "img/ipoteka.41e91ee4.png";